// Денежный ввод и отображение не проходят через Number/IEEE-754.
// Decimal JSON может содержать 0E-8: серверные значения разворачиваем точно.
export function moneyUnits(value: string): bigint | null {
  if (value.length > 128) return null;
  const match = /^(-?)(\d+)(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/.exec(
    value.trim().replace(",", "."),
  );
  if (!match) return null;
  const exponent = Number(match[4] ?? "0");
  if (!Number.isInteger(exponent) || Math.abs(exponent) > 100) return null;
  const fraction = match[3] ?? "";
  const coefficient = BigInt(match[2] + fraction);
  const scale = 8 + exponent - fraction.length;
  const factor = 10n ** BigInt(Math.abs(scale));
  if (scale < 0 && coefficient % factor !== 0n) return null;
  const units = scale < 0 ? coefficient / factor : coefficient * factor;
  return match[1] ? -units : units;
}

export function exactMoney(value: string): string | null {
  const units = moneyUnits(value);
  if (units === null) return null;
  const positive = units < 0n ? -units : units;
  const fraction = String(positive % 100000000n)
    .padStart(8, "0")
    .replace(/0+$/, "");
  return `${units < 0n ? "-" : ""}${positive / 100000000n}${fraction ? `.${fraction}` : ""}`;
}

export function normalizedMoney(value: string): string | null {
  // Для пользовательского ввода экспонента и лишние знаки не допускаются.
  if (!/^-?\d+(?:[.,]\d{1,8})?$/.test(value.trim())) return null;
  return exactMoney(value);
}

export function displayMoney(value: string, brief = false): string {
  const units = moneyUnits(value);
  if (units === null) return "—";
  if (!brief) return (exactMoney(value) ?? "—").replace(".", ",");
  const positive = units < 0n ? -units : units;
  const cents = (positive + 500000n) / 1000000n;
  return `${units < 0n ? "-" : ""}${cents / 100n},${String(cents % 100n).padStart(2, "0")}`;
}
